import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Application, loadCommunity, LoadingIndicator, connectedComponent } from 'gwx-voyager-components';
import InvalidContext from '../App/InvalidContext.react';
import ClaimInvitationFormContainer from './ClaimForm/ClaimInvitationForm.react';

class ClaimPage extends Component {
	UNSAFE_componentWillMount() {
		this.props.loadContext(this.props.context.communityId);
	}

	shouldComponentUpdate(nextProps) {
		if (JSON.stringify(nextProps.context.communityId)
				!== JSON.stringify(this.props.context.communityId)) {
			this.props.loadContext(nextProps.context.communityId);
			return false;
		}

		return true;
	}

	render() {
		if (this.props.context.isFetching) {
			return <LoadingIndicator />;
		}

		if (!this.props.context.isFetching && !this.props.context.community) {
			return <InvalidContext id={this.props.context.communityId} />;
		}

		return (
			<Application
				navigation={{brand: { brandName: this.props.context.community.name, brandClass: 'brand-name', brandUrl: '/'},
				navigationRight: [{ type: 'dropdown', display: this.props.username, options: [{ href: `/profile/${this.props.profileId}`, display: 'Profile'}, { href: this.props.helpLink, display: 'Help'}, { href: this.props.logoutLink, display: 'Logout'}]}]}}
			>
				<ClaimInvitationFormContainer community={this.props.context.community} profileId={this.props.profileId}  />
			</Application>			
		);
	}
}

ClaimPage.defaultProps = {
	helpLink: window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.urls && window.gwx.ui.props.urls.help,
	logoutLink: (window.gwx && window.gwx.ui && window.gwx.ui.props && window.gwx.ui.props.urls &&  window.gwx.ui.props.urls.logout) || '/logout',
	username: (window.gwx && window.gwx.ui && window.gwx.ui.username) || 'User',
	profileId: window.gwx && window.gwx.ui && window.gwx.ui.profileId
}

ClaimPage.propTypes = {
	context: PropTypes.shape({
		isFetching: PropTypes.bool.isRequired,
		communityId: PropTypes.string.isRequired,
		community: PropTypes.shape({
			name: PropTypes.string,
			id: PropTypes.string
		})
	}).isRequired,
	loadContext: PropTypes.func.isRequired,
	helpLink: PropTypes.string,
	logoutLink: PropTypes.string,
	username: PropTypes.string,
	profileId: PropTypes.string
};

const mapStateToProps = (state, props) => {
	const {
		match: { params: { communityId } },
		location: { pathname }
	} = props;

	const {
		entities: { community }
	} = state;

	return {
		context: {
			communityId,
			isFetching: community.isFetching,
			community: community[communityId]
		},
		pathname
	};
};

const mapDispatchToProps = (dispatch) => ({
	/**
	 * Makes a fetch request for the community in context
	 */
	loadContext: (communityId) => dispatch(loadCommunity(communityId, { validateUser: false }))
});

export default connectedComponent(ClaimPage, mapStateToProps, mapDispatchToProps);
